import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungFlensburg() {
  return (
    <CityPageTemplate
      city="Flensburg"
      slug="flensburg"
      intro="Flensburg an der dänischen Grenze – Deine Finanzen kennen keine Grenzen mit FINABLE."
      description="Unabhängige & digitale Finanzberatung für Flensburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
